import { render } from "./ListaAluno.vue?vue&type=template&id=01ee0265"
import script from "./ListaAluno.vue?vue&type=script&lang=js"
export * from "./ListaAluno.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__